export default __webpack_public_path__ + "static/media/E-commerceRealCase2-en.a588b048.jpg";